import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { ODOO } from "./crmV2Helpers";

const COUNTRIES = ["Cameroon", "France", "Nigeria", "Gabon", "Senegal", "Ivory Coast", "Germany", "USA", "United Kingdom", "South Africa", "Kenya", "Egypt"];
const INDUSTRIES = ["Technology", "Finance", "Healthcare", "Retail", "Manufacturing", "Education", "Energy", "Transport", "Telecom", "Agriculture", "Automotive", "Construction"];
const SIZE_OPTIONS = ["1-10", "11-50", "51-200", "201-500", "500+"];
const ROLES = ["CEO", "CTO", "CFO", "COO", "Manager", "Sales Manager", "Marketing Manager", "HR Manager", "Business Analyst", "Engineer", "Consultant"];
const SENIORITIES = ["Entry", "Junior", "Senior", "Manager", "Director", "Executive", "Owner", "Partner", "VP", "Head"];
const DEFAULT_TAGS_OPTIONS = ["Hot", "Cold", "VIP", "Partner", "New", "Follow Up", "Qualified"];

const labelStyle = {
  fontSize: 11,
  fontWeight: 600,
  color: "#495057",
  width: 110,
  minWidth: 110,
  flexShrink: 0,
  textAlign: "left",
  paddingTop: 6,
};

const inputUnderline = {
  width: "100%",
  border: "none",
  borderBottom: `1px solid ${ODOO.border}`,
  borderRadius: 0,
  padding: "6px 0",
  fontSize: 13,
  background: "transparent",
  outline: "none",
  fontFamily: "inherit",
  color: ODOO.text,
};

const tagPill = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  background: "#e9ecef",
  border: `1px solid ${ODOO.border}`,
  borderRadius: 12,
  padding: "2px 8px",
  fontSize: 12,
  color: ODOO.text,
};

  const dropdownPanelStyle = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  zIndex: 1400,
  marginTop: 4,
  border: `1px solid ${ODOO.border}`,
  borderRadius: 4,
  background: "#fff",
  boxShadow: "0 12px 28px rgba(0,0,0,0.16), 0 6px 14px rgba(0,0,0,0.10)",
  overflow: "hidden",
  maxHeight: 220,
  overflowY: "auto",
};

const optionBtn = {
  display: "block",
  width: "100%",
  textAlign: "left",
  border: "none",
  background: "transparent",
  padding: "7px 10px",
  fontSize: 13,
  cursor: "pointer",
  fontFamily: "inherit",
  color: ODOO.text,
};
 
const searchMoreBtn = {
  ...optionBtn,
  color: ODOO.primary,
  fontWeight: 600,
  borderTop: `1px solid ${ODOO.border}`,
  background: "#fafbfc",
};

const CrmV2GenerateLeadsModal = ({ open, onClose, onGenerate, teams = [], users = [] }) => {
  // Type de le + count
  const [leadMode, setLeadMode] = useState("companies");
  const [count, setCount] = useState(3);
  const [extraContacts, setExtraContacts] = useState(5);
  const [filterOn, setFilterOn] = useState("role");

  // Left column - targeting
  const [countries, setCountries] = useState(["Cameroon"]);
  const [countryInput, setCountryInput] = useState("");
  const [showCountryList, setShowCountryList] = useState(false);

  const [industries, setIndustries] = useState([]);
  const [industryInput, setIndustryInput] = useState("");
  const [showIndustryList, setShowIndustryList] = useState(false);

  const [filterOnSize, setFilterOnSize] = useState(false);
  const [selectedSizes, setSelectedSizes] = useState([]);

  // Conditional dependent fields
  const [preferredRole, setPreferredRole] = useState("");
  const [preferredRoleInput, setPreferredRoleInput] = useState("");
  const [showRoleList, setShowRoleList] = useState(false);

  const [seniority, setSeniority] = useState("");
  const [seniorityInput, setSeniorityInput] = useState("");
  const [showSeniorityList, setShowSeniorityList] = useState(false);

  // Right column - attribution
  const [salesTeam, setSalesTeam] = useState("");
  const [salesTeamInput, setSalesTeamInput] = useState("");
  const [showTeamList, setShowTeamList] = useState(false);

  const [salesperson, setSalesperson] = useState("");
  const [salespersonInput, setSalespersonInput] = useState("");
  const [showSalespersonList, setShowSalespersonList] = useState(false);

  const [defaultTags, setDefaultTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [showTagList, setShowTagList] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const addCountry = (c) => {
    if (!countries.includes(c)) setCountries((p) => [...p, c]);
    setCountryInput("");
    setShowCountryList(false);
  };
  const removeCountry = (c) => setCountries((p) => p.filter((x) => x !== c));

  const addIndustry = (ind) => {
    if (!industries.includes(ind)) setIndustries((p) => [...p, ind]);
    setIndustryInput("");
    setShowIndustryList(false);
  };
  const removeIndustry = (ind) => setIndustries((p) => p.filter((x) => x !== ind));

  const addTag = (v) => {
    const val = (v ?? tagInput).trim();
    if (!val) return;
    if (!defaultTags.includes(val)) setDefaultTags((p) => [...p, val]);
    setTagInput("");
    setShowTagList(false);
  };

  const handleGenerate = () => {
    const payload = {
      leadMode,
      count: Number(count) || 0,
      extraContacts: leadMode === "companies_contacts" ? Number(extraContacts) || 0 : undefined,
      filterOn: leadMode === "companies_contacts" ? filterOn : undefined,
      preferredRole: leadMode === "companies_contacts" && filterOn === "role" ? preferredRole : undefined,
      seniority: leadMode === "companies_contacts" && filterOn === "seniority" ? seniority : undefined,
      countries,
      industries,
      filterOnSize,
      selectedSizes,
      salesTeam,
      salesperson,
      defaultTags,
    };
    onGenerate?.(payload);
  };

  const handleSearchMore = (field) => {
    // Odoo: ouvre une vue de recherche étendue — ici on simule
    // On pourrait ouvrir un modal secondaire, pour l'instant on ferme le dropdown
    setShowCountryList(false);
    setShowIndustryList(false);
    setShowRoleList(false);
    setShowSeniorityList(false);
    setShowTeamList(false);
    setShowSalespersonList(false);
    setShowTagList(false);
    // Feedback visuel léger (le parent pourra brancher une vraie vue)
    // eslint-disable-next-line no-alert
    if (typeof window !== "undefined" && window.toast) window.toast(`Search More — ${field}`, "info");
  };

  const filteredCountries = COUNTRIES.filter((c) => c.toLowerCase().includes(countryInput.toLowerCase()) && !countries.includes(c)).slice(0, 6);
  const filteredIndustries = INDUSTRIES.filter((i) => i.toLowerCase().includes(industryInput.toLowerCase()) && !industries.includes(i)).slice(0, 6);
  const filteredRoles = ROLES.filter((r) => r.toLowerCase().includes(preferredRoleInput.toLowerCase())).slice(0, 6);
  const filteredSeniorities = SENIORITIES.filter((s) => s.toLowerCase().includes(seniorityInput.toLowerCase())).slice(0, 6);
  const filteredTeams = teams.filter((t) => t.name.toLowerCase().includes(salesTeamInput.toLowerCase())).slice(0, 6);
  const filteredUsers = users.filter((u) => (u.name || u.username || u.email || "").toLowerCase().includes(salespersonInput.toLowerCase())).slice(0, 6);
  const filteredTags = DEFAULT_TAGS_OPTIONS.filter((t) => t.toLowerCase().includes(tagInput.toLowerCase()) && !defaultTags.includes(t)).slice(0, 6);

  const teamLabel = teams.find((t) => String(t.id) === String(salesTeam))?.name || salesTeam;
  const userLabel = users.find((u) => String(u.id) === String(salesperson))?.name || users.find((u) => String(u.id) === String(salesperson))?.username || users.find((u) => String(u.id) === String(salesperson))?.email || salesperson;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        background: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(2px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Generate Leads"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 880,
          maxWidth: "96vw",
          maxHeight: "96vh",
          overflow: "visible",
          background: "#fff",
          borderRadius: 6,
          boxShadow: "0 24px 60px rgba(0,0,0,0.28), 0 8px 20px rgba(0,0,0,0.18)",
          fontFamily: '"Lucida Grande", Helvetica, Verdana, Arial, sans-serif',
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px 14px", borderBottom: `1px solid ${ODOO.border}`, flexShrink: 0 }}>
          <h2 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: ODOO.text, letterSpacing: "-0.01em" }}>Generate Leads</h2>
          <button type="button" onClick={onClose} aria-label="Close" style={{ border: "none", background: "transparent", cursor: "pointer", color: ODOO.muted, display: "inline-flex", padding: 4, lineHeight: 1 }}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px 24px", overflow: "visible" }}>
          <div style={{ fontSize: 17, fontWeight: 600, color: ODOO.text, marginBottom: 14 }}>What do you need ?</div>

          {/* Inline numeric + type de lead — le select remplace le span Companies inutile */}
          <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: leadMode === "companies_contacts" ? 16 : 24, flexWrap: "wrap" }}>
            <input
              type="number"
              min={1}
              max={1000}
              value={count}
              onChange={(e) => setCount(e.target.value)}
              style={{
                width: 56,
                border: "none",
                borderBottom: `1px solid ${ODOO.text}`,
                borderRadius: 0,
                padding: "4px 6px",
                fontSize: 15,
                fontWeight: 600,
                textAlign: "center",
                outline: "none",
                fontFamily: "inherit",
                background: "transparent",
                color: ODOO.text,
              }}
            />
            <select
              value={leadMode}
              onChange={(e) => setLeadMode(e.target.value)}
              style={{
                border: "none",
                borderBottom: `1px solid ${ODOO.text}`,
                padding: "4px 6px 4px 2px",
                fontSize: 14,
                background: "transparent",
                outline: "none",
                fontFamily: "inherit",
                color: ODOO.text,
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              <option value="companies">Companies</option>
              <option value="companies_contacts">Companies and their Contacts</option>
            </select>
          </div>

          {/* Bloc conditionnel : Companies and their Contacts */}
          {leadMode === "companies_contacts" && (
            <div style={{ marginBottom: 24, padding: "14px 16px", background: "#fafbfc", border: `1px solid ${ODOO.borderLight}`, borderRadius: 4 }}>
              <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
                <input
                  type="number"
                  min={1}
                  max={20}
                  value={extraContacts}
                  onChange={(e) => setExtraContacts(e.target.value)}
                  style={{
                    width: 56,
                    border: "none",
                    borderBottom: `1px solid ${ODOO.text}`,
                    borderRadius: 0,
                    padding: "4px 6px",
                    fontSize: 15,
                    fontWeight: 600,
                    textAlign: "center",
                    outline: "none",
                    fontFamily: "inherit",
                    background: "#fff",
                    color: ODOO.text,
                  }}
                />
                <span style={{ fontSize: 13, color: ODOO.text, borderBottom: `1px solid ${ODOO.text}`, paddingBottom: 4 }}>Extra contacts per Company</span>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 12, flexWrap: "wrap" }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: ODOO.muted }}>Filter on</span>
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, color: ODOO.text }}>
                  <input type="radio" name="filterOn" checked={filterOn === "role"} onChange={() => setFilterOn("role")} style={{ accentColor: ODOO.primary }} />
                  Role
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, color: ODOO.text }}>
                  <input type="radio" name="filterOn" checked={filterOn === "seniority"} onChange={() => setFilterOn("seniority")} style={{ accentColor: ODOO.primary }} />
                  Seniority
                </label>
              </div>

              {/* Champ dépendant */}
              {filterOn === "role" ? (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <label style={labelStyle}>Preferred Role</label>
                  <div style={{ flex: 1, position: "relative" }}>
                    <input
                      value={preferredRole ? ROLES.find((r) => r === preferredRole) || preferredRole : preferredRoleInput}
                      onChange={(e) => { setPreferredRole(""); setPreferredRoleInput(e.target.value); setShowRoleList(true); }}
                      onFocus={() => setShowRoleList(true)}
                      onBlur={() => setTimeout(() => setShowRoleList(false), 150)}
                      placeholder="Select role..."
                      style={inputUnderline}
                    />
                    {showRoleList && (
                      <div style={dropdownPanelStyle}>
                        {filteredRoles.map((r) => (
                          <button key={r} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { setPreferredRole(r); setPreferredRoleInput(""); setShowRoleList(false); }} style={optionBtn}>{r}</button>
                        ))}
                        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Preferred Role")} style={searchMoreBtn}>Search More...</button>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <label style={labelStyle}>Seniority</label>
                  <div style={{ flex: 1, position: "relative" }}>
                    <input
                      value={seniority ? SENIORITIES.find((s) => s === seniority) || seniority : seniorityInput}
                      onChange={(e) => { setSeniority(""); setSeniorityInput(e.target.value); setShowSeniorityList(true); }}
                      onFocus={() => setShowSeniorityList(true)}
                      onBlur={() => setTimeout(() => setShowSeniorityList(false), 150)}
                      placeholder="Select seniority..."
                      style={inputUnderline}
                    />
                    {showSeniorityList && (
                      <div style={dropdownPanelStyle}>
                        {filteredSeniorities.map((s) => (
                          <button key={s} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { setSeniority(s); setSeniorityInput(""); setShowSeniorityList(false); }} style={optionBtn}>{s}</button>
                        ))}
                        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Seniority")} style={searchMoreBtn}>Search More...</button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Two columns - strict Odoo layout labels left */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px 32px" }}>
            {/* Left */}
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              {/* Countries - Multi Tags */}
              <div style={{ display: "flex", gap: 8 }}>
                <label style={labelStyle}>Countries</label>
                <div style={{ flex: 1, position: "relative" }}>
                  <div
                    onClick={() => setShowCountryList(true)}
                    style={{
                      minHeight: 28,
                      borderBottom: `1px solid ${ODOO.border}`,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                      alignItems: "center",
                      padding: "4px 0",
                      cursor: "text",
                    }}
                  >
                    {countries.map((c) => (
                      <span key={c} style={tagPill}>
                        {c}
                        <button type="button" onClick={(e) => { e.stopPropagation(); removeCountry(c); }} style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0, fontSize: 12, lineHeight: 1, color: ODOO.muted }}>✕</button>
                      </span>
                    ))}
                    <input
                      value={countryInput}
                      onChange={(e) => { setCountryInput(e.target.value); setShowCountryList(true); }}
                      onFocus={() => setShowCountryList(true)}
                      onBlur={() => setTimeout(() => setShowCountryList(false), 150)}
                      placeholder={countries.length ? "" : "Search..."}
                      style={{ border: "none", outline: "none", fontSize: 13, minWidth: 80, flex: 1, fontFamily: "inherit", background: "transparent" }}
                    />
                  </div>
                  {showCountryList && (
                    <div style={dropdownPanelStyle}>
                      {filteredCountries.map((c) => (
                        <button key={c} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => addCountry(c)} style={optionBtn}>{c}</button>
                      ))}
                      {filteredCountries.length === 0 && countryInput.trim() && <div style={{ padding: "7px 10px", fontSize: 12, color: ODOO.muted }}>No match</div>}
                      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Countries")} style={searchMoreBtn}>Search More...</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Industries - Multi Tags */}
              <div style={{ display: "flex", gap: 8 }}>
                <label style={labelStyle}>Industries</label>
                <div style={{ flex: 1, position: "relative" }}>
                  <div
                    onClick={() => setShowIndustryList(true)}
                    style={{
                      minHeight: 28,
                      borderBottom: `1px solid ${ODOO.border}`,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                      alignItems: "center",
                      padding: "4px 0",
                      cursor: "text",
                    }}
                  >
                    {industries.map((ind) => (
                      <span key={ind} style={tagPill}>
                        {ind}
                        <button type="button" onClick={(e) => { e.stopPropagation(); removeIndustry(ind); }} style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0, fontSize: 12, lineHeight: 1, color: ODOO.muted }}>✕</button>
                      </span>
                    ))}
                    <input
                      value={industryInput}
                      onChange={(e) => { setIndustryInput(e.target.value); setShowIndustryList(true); }}
                      onFocus={() => setShowIndustryList(true)}
                      onBlur={() => setTimeout(() => setShowIndustryList(false), 150)}
                      placeholder={industries.length ? "" : "Search..."}
                      style={{ border: "none", outline: "none", fontSize: 13, minWidth: 80, flex: 1, fontFamily: "inherit", background: "transparent" }}
                    />
                  </div>
                  {showIndustryList && (
                    <div style={dropdownPanelStyle}>
                      {filteredIndustries.map((ind) => (
                        <button key={ind} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => addIndustry(ind)} style={optionBtn}>{ind}</button>
                      ))}
                      {filteredIndustries.length === 0 && industryInput.trim() && <div style={{ padding: "7px 10px", fontSize: 12, color: ODOO.muted }}>No match</div>}
                      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Industries")} style={searchMoreBtn}>Search More...</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Filter on Size */}
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <label style={labelStyle}>Filter on Size</label>
                <div style={{ flex: 1 }}>
                  <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, color: ODOO.text }}>
                    <input type="checkbox" checked={filterOnSize} onChange={(e) => setFilterOnSize(e.target.checked)} style={{ width: 16, height: 16, accentColor: ODOO.primary }} />
                    <span style={{ fontSize: 12, color: ODOO.muted }}>Enable</span>
                  </label>
                  {filterOnSize && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
                      {SIZE_OPTIONS.map((sz) => (
                        <label key={sz} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, color: ODOO.text, cursor: "pointer", border: `1px solid ${ODOO.border}`, borderRadius: 4, padding: "3px 8px", background: selectedSizes.includes(sz) ? ODOO.primarySoft : "#fff" }}>
                          <input type="checkbox" checked={selectedSizes.includes(sz)} onChange={(e) => setSelectedSizes((p) => e.target.checked ? [...p, sz] : p.filter((x) => x !== sz))} style={{ width: 13, height: 13 }} />
                          {sz}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right */}
            <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
              {/* Sales Team - Single Autocomplete */}
              <div style={{ display: "flex", gap: 8 }}>
                <label style={labelStyle}>Sales Team</label>
                <div style={{ flex: 1, position: "relative" }}>
                  <input
                    value={showTeamList ? salesTeamInput : teamLabel || salesTeamInput}
                    onChange={(e) => { setSalesTeamInput(e.target.value); setSalesTeam(""); setShowTeamList(true); }}
                    onFocus={() => { setSalesTeamInput(salesTeam ? teamLabel : ""); setShowTeamList(true); }}
                    onBlur={() => setTimeout(() => setShowTeamList(false), 150)}
                    placeholder="Select team..."
                    style={inputUnderline}
                  />
                  {showTeamList && (
                    <div style={dropdownPanelStyle}>
                      {filteredTeams.map((t) => (
                        <button key={t.id} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { setSalesTeam(String(t.id)); setSalesTeamInput(""); setShowTeamList(false); }} style={optionBtn}>{t.name}</button>
                      ))}
                      {filteredTeams.length === 0 && <div style={{ padding: "7px 10px", fontSize: 12, color: ODOO.muted }}>No team found</div>}
                      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Sales Team")} style={searchMoreBtn}>Search More...</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Salesperson - Single Autocomplete */}
              <div style={{ display: "flex", gap: 8 }}>
                <label style={labelStyle}>Salesperson</label>
                <div style={{ flex: 1, position: "relative" }}>
                  <input
                    value={showSalespersonList ? salespersonInput : userLabel || salespersonInput}
                    onChange={(e) => { setSalespersonInput(e.target.value); setSalesperson(""); setShowSalespersonList(true); }}
                    onFocus={() => { setSalespersonInput(salesperson ? userLabel : ""); setShowSalespersonList(true); }}
                    onBlur={() => setTimeout(() => setShowSalespersonList(false), 150)}
                    placeholder="Select salesperson..."
                    style={inputUnderline}
                  />
                  {showSalespersonList && (
                    <div style={dropdownPanelStyle}>
                      {filteredUsers.map((u) => (
                        <button key={u.id} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { setSalesperson(String(u.id)); setSalespersonInput(""); setShowSalespersonList(false); }} style={optionBtn}>{u.name || u.username || u.email}</button>
                      ))}
                      {filteredUsers.length === 0 && <div style={{ padding: "7px 10px", fontSize: 12, color: ODOO.muted }}>No user found</div>}
                      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Salesperson")} style={searchMoreBtn}>Search More...</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Default Tags - Multi with Search More / Start typing */}
              <div style={{ display: "flex", gap: 8 }}>
                <label style={labelStyle}>Default Tags</label>
                <div style={{ flex: 1, position: "relative" }}>
                  <div
                    onClick={() => setShowTagList(true)}
                    style={{
                      minHeight: 28,
                      borderBottom: `1px solid ${ODOO.border}`,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                      alignItems: "center",
                      padding: "4px 0",
                      cursor: "text",
                    }}
                  >
                    {defaultTags.map((t) => (
                      <span key={t} style={tagPill}>
                        {t}
                        <button type="button" onClick={(e) => { e.stopPropagation(); setDefaultTags((p) => p.filter((x) => x !== t)); }} style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0, fontSize: 12, lineHeight: 1, color: ODOO.muted }}>✕</button>
                      </span>
                    ))}
                    <input
                      value={tagInput}
                      onChange={(e) => { setTagInput(e.target.value); setShowTagList(true); }}
                      onFocus={() => setShowTagList(true)}
                      onBlur={() => setTimeout(() => setShowTagList(false), 150)}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); addTag(); } if (e.key === "Backspace" && !tagInput && defaultTags.length) setDefaultTags((p) => p.slice(0, -1)); }}
                      placeholder={defaultTags.length ? "" : "Add tags..."}
                      style={{ border: "none", outline: "none", fontSize: 13, minWidth: 80, flex: 1, fontFamily: "inherit", background: "transparent" }}
                    />
                  </div>
                  {showTagList && (
                    <div style={dropdownPanelStyle}>
                      {filteredTags.map((t) => (
                        <button key={t} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => addTag(t)} style={optionBtn}>{t}</button>
                      ))}
                      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => handleSearchMore("Default Tags")} style={searchMoreBtn}>{tagInput.trim() ? "Search More..." : "Start typing..."}</button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 24px", borderTop: `1px solid ${ODOO.border}`, background: "#fff", flexShrink: 0 }}>
          <button
            type="button"
            onClick={handleGenerate}
            style={{
              background: "#5b7a99",
              color: "#fff",
              border: "none",
              borderRadius: 3,
              padding: "8px 16px",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: "0.04em",
              cursor: "pointer",
              fontFamily: "inherit",
              textTransform: "uppercase",
            }}
          >
            Generate Leads
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              color: ODOO.text,
              border: "none",
              padding: "8px 12px",
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: "0.04em",
              cursor: "pointer",
              fontFamily: "inherit",
              textTransform: "uppercase",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmV2GenerateLeadsModal;
